import React, {Suspense} from 'react';
import reportWebVitals from './reportWebVitals';
import i18next from 'i18next';
import {initReactI18next} from 'react-i18next';
import App from './App';
import {BrowserRouter as Router} from 'react-router-dom';
import store from './redux/store';
import {Provider} from 'react-redux';
import {createRoot} from 'react-dom/client';
import {PrimeReactProvider} from "primereact/api";

i18next
    .use(initReactI18next)
    .init({
        lng: 'de',
        fallbackLng: 'de',
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false
        },
        resources: {},
    });

const BaseName = '/';

const container: any = document.getElementById('root');
const root = createRoot(container);

const value = {
    hideOverlaysOnDocumentScrolling: false,
};

root.render(
    <PrimeReactProvider value={value}>
        <Provider store={store}>
            <Router basename={BaseName}>
                <Suspense fallback={<div>...</div>}>
                    <React.StrictMode>
                        <App/>
                    </React.StrictMode>
                </Suspense>
            </Router>
        </Provider>
    </PrimeReactProvider>
);

reportWebVitals();
